import React from "react";
import { Modal } from "react-bootstrap";
import AddVentaForm from "./AddVentaForm";

const ModalEditarVentaCompleta = ({ show, handleClose, venta, onSaved }) => {
  return (
    <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static">
      <Modal.Header closeButton className="bg-dark text-white">
        <Modal.Title>
          Modificar Venta N° {venta?.nroventa || ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ background: "#f8fafc", maxHeight: "80vh", overflowY: "auto" }}>
        <AddVentaForm
          modo="editar"
          ventaEditar={venta}
          setShow={() => handleClose()}
          onSaved={onSaved}
          compacto
        />
      </Modal.Body>
    </Modal>
  );
};

export default ModalEditarVentaCompleta;